(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cachoteries-about"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-about-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-about-track]');
    const slides = carousel.querySelectorAll('.about__slide');
    const dots = carousel.querySelectorAll('.about__dot');
    const prev = carousel.querySelector('[data-about-prev]');
    const next = carousel.querySelector('[data-about-next]');

    if (!slides.length) return;

    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

    let current = 0;
    let timer;

    function setActiveDot(index) {
      dots[current].classList.remove('about__dot--active');
      current = index;
      dots[current].classList.add('about__dot--active');
    }

    function goTo(index) {
      index = (index + slides.length) % slides.length;
      if (isMobile()) {
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
        setActiveDot(index);
      } else {
        slides[current].classList.remove('about__slide--active');
        setActiveDot(index);
        slides[current].classList.add('about__slide--active');
      }
    }

    function startAuto() {
      if (isMobile()) return;
      timer = setInterval(() => goTo(current + 1), 5000);
    }

    function resetAuto() {
      clearInterval(timer);
      startAuto();
    }

    if (prev) prev.addEventListener('click', () => { goTo(current - 1); resetAuto(); });
    if (next) next.addEventListener('click', () => { goTo(current + 1); resetAuto(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); resetAuto(); }));

    let scrollTimeout;
    track.addEventListener('scroll', () => {
      if (!isMobile()) return;
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== current && slides[index]) setActiveDot(index);
      }, 100);
    }, { passive: true });

    startAuto();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-atelier-booking"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-wrap]').forEach((wrap) => {
    const video = wrap.querySelector('[data-atelier-video]');
    const playBtn = wrap.querySelector('[data-video-play-toggle]');

    playBtn.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
        wrap.classList.add('is-playing');
      } else {
        video.pause();
        wrap.classList.remove('is-playing');
      }
    });

    video.addEventListener('ended', () => {
      wrap.classList.remove('is-playing');
    });
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-contact-popup-trigger]');
    if (trigger) {
      const popup = document.querySelector('[data-contact-popup="' + trigger.dataset.contactPopupTrigger + '"]');
      if (popup) popup.hidden = false;
      return;
    }
    const closeEl = event.target.closest('[data-contact-popup-close]');
    if (closeEl) {
      closeEl.closest('[data-contact-popup]').hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-contact-popup]:not([hidden])').forEach((popup) => {
      popup.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-atelier-formats"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-contact-popup-trigger]');
    if (trigger) {
      const popup = document.querySelector('[data-contact-popup="' + trigger.dataset.contactPopupTrigger + '"]');
      if (popup) popup.hidden = false;
      return;
    }
    const closeEl = event.target.closest('[data-contact-popup-close]');
    if (closeEl) {
      closeEl.closest('[data-contact-popup]').hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-contact-popup]:not([hidden])').forEach((popup) => {
      popup.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-atelier-timetable"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-timetable-grid]').forEach((grid) => {
    const section = grid.closest('.atelier-timetable');
    const confirmPanel = section.querySelector('[data-timetable-confirm]');
    const confirmLabel = section.querySelector('[data-timetable-confirm-label]');
    const cancelBtn = section.querySelector('[data-timetable-cancel]');
    const slots = grid.querySelectorAll('.atelier-timetable__slot--available');

    slots.forEach((slot) => {
      slot.addEventListener('click', () => {
        slots.forEach((s) => s.classList.remove('atelier-timetable__slot--selected'));
        slot.classList.add('atelier-timetable__slot--selected');

        const date = slot.dataset.date;
        const time = slot.dataset.time;
        const spots = slot.dataset.spots;
        confirmLabel.textContent = `${date} · ${time} · ${spots} place${spots > 1 ? 's' : ''} disponible${spots > 1 ? 's' : ''}`;

        confirmPanel.hidden = false;
        confirmPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => {
        slots.forEach((s) => s.classList.remove('atelier-timetable__slot--selected'));
        confirmPanel.hidden = true;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-collection-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-collection-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('.collection-bar__filters').forEach((bar) => {
    const buttons = bar.querySelectorAll('.collection-bar__filter');
    const grid = document.querySelector('.collection-grid__grid');
    if (!grid) return;

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach((b) => b.classList.remove('collection-bar__filter--active'));
        btn.classList.add('collection-bar__filter--active');

        const filter = btn.dataset.filter;
        grid.querySelectorAll('.product-card').forEach((card) => {
          const show = filter === 'tout' || card.dataset.category === filter;
          card.hidden = !show;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-collection-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-contact-popup-trigger]');
    if (trigger) {
      const popup = document.querySelector('[data-contact-popup="' + trigger.dataset.contactPopupTrigger + '"]');
      if (popup) popup.hidden = false;
      return;
    }
    const closeEl = event.target.closest('[data-contact-popup-close]');
    if (closeEl) {
      closeEl.closest('[data-contact-popup]').hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-contact-popup]:not([hidden])').forEach((popup) => {
      popup.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-confiance"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-clients-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const list = toggle.closest('[data-clients-list]');
      const label = toggle.querySelector('[data-clients-toggle-label]');
      const expanded = list.dataset.expanded === 'true';

      list.dataset.expanded = expanded ? 'false' : 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      label.textContent = expanded ? label.dataset.showMore : label.dataset.showLess;

      if (expanded) {
        list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-devis-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.getElementById('devis-form-section');
    if (!section) return;

    const form = section.querySelector('#devis-form');
    const steps = Array.from(section.querySelectorAll('.devis-step'));
    const progressEl = section.querySelector('.devis-form__progress');
    const progressFill = section.querySelector('.devis-form__progress-fill');
    const progressLabel = section.querySelector('.devis-form__progress-label');

    const state = { profil: null };

    const CONTEXT_LISTS = {
      particulier: [
        'Mariage', 'Anniversaire', 'EVJF / EVG', 'Baptême', 'Fiançailles',
        'Remise de diplôme', 'Cadeau surprise, sans occasion particulière', 'Autre'
      ],
      professionnel: [
        'Séminaire ou événement interne', 'Opération marketing ou communication',
        'Cadeau client ou partenaire', 'Réassort pour mon établissement (hôtel, café, boutique…)',
        'Lancement de produit', 'Salon ou événement professionnel', 'Cadeaux de fin d’année', 'Autre'
      ]
    };

    const FORMULE_LABELS = {
      tout_nu: '100 % Tout nus',
      pimpes: '100 % Pimpés',
      mix_50_50: 'Mix 50-50',
      mix_70_30: 'Mix 70 % Pimpés – 30 % Tout nus',
      mix_2_pimpes: 'Mix 2 pimpés différents',
      repartition_perso: 'Répartition personnalisée',
      conseil: 'Je ne sais pas, conseillez-moi'
    };

    const FORMULE_LINES = {
      tout_nu: ['Tout nu'],
      pimpes: ['Pimpé'],
      mix_50_50: ['Pimpé (50 %)', 'Tout nu (50 %)'],
      mix_70_30: ['Pimpé (70 %)', 'Tout nu (30 %)'],
      mix_2_pimpes: ['Pimpé — variante 1', 'Pimpé — variante 2'],
      repartition_perso: null, // calculé depuis le curseur
      conseil: ['Votre sélection (à définir avec l’atelier)']
    };

    const PROGRESS_PARTICULIER = ['connaissance', 'projet', 'formule', 'personnalisation', 'conditionnement', 'mots', 'abonnement', 'recap'];
    const PROGRESS_PRO = ['connaissance', 'proChoix', 'projet', 'formule', 'personnalisation', 'conditionnement', 'mots', 'abonnement', 'recap'];

    function el(selector, root) {
      return (root || section).querySelector(selector);
    }

    function els(selector, root) {
      return Array.from((root || section).querySelectorAll(selector));
    }

    // --- Validation dynamique -------------------------------------------------

    function syncAllRequired() {
      els('[data-required]').forEach((field) => {
        field.required = !field.closest('[hidden]');
      });

      const nappage = els('[data-nappage]');
      if (nappage.length) {
        const visible = !nappage[0].closest('[hidden]');
        const anyChecked = nappage.some((c) => c.checked);
        nappage.forEach((c) => { c.required = visible && !anyChecked; });
      }
    }

    // --- Navigation -------------------------------------------------------

    function currentStepKey() {
      const visible = steps.find((s) => !s.hidden);
      return visible ? visible.dataset.step : null;
    }

    function nextStepKey(current) {
      switch (current) {
        case 'garde': return 'attendez';
        case 'attendez': return 'connaissance';
        case 'connaissance': return state.profil === 'professionnel' ? 'proChoix' : 'projet';
        case 'proChoix': return state.avancer === 'rappel' ? 'exitRdv' : 'projet';
        case 'projet': return 'formule';
        case 'formule': return 'personnalisation';
        case 'personnalisation': return 'conditionnement';
        case 'conditionnement': return 'mots';
        case 'mots': return 'abonnement';
        case 'abonnement': return 'recap';
        case 'recap': return 'merci';
        default: return null;
      }
    }

    function prevStepKey(current) {
      switch (current) {
        case 'attendez': return 'garde';
        case 'connaissance': return 'attendez';
        case 'proChoix': return 'connaissance';
        case 'projet': return state.profil === 'professionnel' ? 'proChoix' : 'connaissance';
        case 'formule': return 'projet';
        case 'personnalisation': return 'formule';
        case 'conditionnement': return 'personnalisation';
        case 'mots': return 'conditionnement';
        case 'abonnement': return 'mots';
        case 'recap': return 'abonnement';
        default: return null;
      }
    }

    function updateProgress(key) {
      const list = state.profil === 'professionnel' ? PROGRESS_PRO : PROGRESS_PARTICULIER;
      const idx = list.indexOf(key);
      if (idx === -1) {
        progressEl.hidden = true;
        return;
      }
      progressEl.hidden = false;
      const pct = Math.round(((idx + 1) / list.length) * 100);
      progressFill.style.width = pct + '%';
      progressLabel.textContent = 'Étape ' + (idx + 1) + ' sur ' + list.length;
    }

    function showStep(key) {
      steps.forEach((s) => { s.hidden = s.dataset.step !== key; });
      syncAllRequired();
      updateProgress(key);
      if (key === 'mots') renderMessageFields();
      if (key === 'recap') renderRecap();
      window.scrollTo({ top: Math.max(section.offsetTop - 24, 0), behavior: 'smooth' });
    }

    function handleNext() {
      const current = currentStepKey();
      if (!current) return;
      if (!form.reportValidity()) return;
      const next = nextStepKey(current);
      if (next) showStep(next);
    }

    function handleBack() {
      const current = currentStepKey();
      if (!current) return;
      const prev = prevStepKey(current);
      if (prev) showStep(prev);
    }

    section.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-nav]');
      if (!btn) return;
      if (btn.dataset.nav === 'next') {
        handleNext();
      } else {
        handleBack();
      }
    });

    // --- Écran 3 : profil particulier / professionnel ----------------------

    function populateContexteSelect(profil) {
      const select = el('#devis-contexte');
      if (!select) return;
      const list = CONTEXT_LISTS[profil] || CONTEXT_LISTS.particulier;
      select.innerHTML = '<option value="" selected disabled>Choisir…</option>' +
        list.map((label) => '<option value="' + label.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '">' + label + '</option>').join('');
    }

    function onProfilChange(value) {
      state.profil = value;
      els('.devis-form__pro-only').forEach((wrap) => { wrap.hidden = value !== 'professionnel'; });
      populateContexteSelect(value === 'professionnel' ? 'professionnel' : 'particulier');
      syncAllRequired();
    }

    // --- Écran 4 : contexte "autre" + date de livraison ---------------------

    el('#devis-contexte').addEventListener('change', (event) => {
      el('.devis-form__contexte-autre').hidden = event.target.value !== 'autre';
      syncAllRequired();
    });

    function onPrecisionLivraisonChange(value) {
      el('.devis-form__date-livraison').hidden = value !== 'precise';
      syncAllRequired();
    }

    // --- Écran 5 : formule + répartition -------------------------------------

    function onFormuleChange(value) {
      const nappageBlock = el('.devis-form__nappage-block');
      const toppingsBlock = el('.devis-form__toppings-block');
      const repartitionBlock = el('.devis-form__repartition');

      nappageBlock.hidden = value === 'tout_nu';
      repartitionBlock.hidden = value !== 'repartition_perso';

      if (nappageBlock.hidden) {
        toppingsBlock.hidden = true;
      } else {
        updateToppingsVisibility();
      }
      syncAllRequired();
    }

    function updateToppingsVisibility() {
      const nappageChecked = els('.devis-form__nappage').some((c) => c.checked);
      el('.devis-form__toppings-block').hidden = !nappageChecked;
      syncAllRequired();
    }

    els('.devis-form__nappage').forEach((cb) => {
      cb.addEventListener('change', () => {
        updateToppingsVisibility();
      });
    });

    const repartitionInput = el('input[name="repartition_pimpe"]');
    const repartitionValue = el('.devis-form__repartition-value');
    function updateRepartitionLabel() {
      const pimpe = Number(repartitionInput.value);
      repartitionValue.textContent = pimpe + ' % Pimpés / ' + (100 - pimpe) + ' % Tout nus';
    }
    repartitionInput.addEventListener('input', updateRepartitionLabel);
    updateRepartitionLabel();

    // --- Écran 6 : toppings max 4, "je ne sais pas" exclusif ----------------

    els('.devis-form__topping').forEach((cb) => {
      cb.addEventListener('change', () => {
        const group = els('.devis-form__topping');
        const dontKnow = group.find((c) => c.value === 'je_ne_sais_pas');

        if (cb === dontKnow && cb.checked) {
          group.forEach((other) => { if (other !== dontKnow) other.checked = false; });
        } else if (cb.checked && dontKnow && dontKnow.checked) {
          dontKnow.checked = false;
        }

        const checkedCount = group.filter((c) => c.checked && c !== dontKnow).length;
        if (checkedCount > 4) {
          cb.checked = false;
        }
      });
    });

    // --- Écran 7 : bocal/VRAC uniquement si retrait boutique -----------------

    function onModeLivraisonChange(value) {
      const boutiqueOnly = els('.devis-form__option--boutique-only');
      boutiqueOnly.forEach((wrap) => {
        wrap.hidden = value !== 'retrait';
        if (wrap.hidden) {
          const input = wrap.querySelector('input');
          if (input) input.checked = false;
        }
      });
    }

    // --- Écran 3 bis : branche rappel ---------------------------------------

    function onAvancerChange(value) {
      el('.devis-form__rappel').hidden = value !== 'rappel';
      syncAllRequired();
    }

    // --- Écran 8 : messages ---------------------------------------------------

    function onRedactionChange(value) {
      el('.devis-form__messages-now').hidden = value !== 'maintenant';
      el('.devis-form__messages-later').hidden = value !== 'reflechir';
      syncAllRequired();
    }

    function renderMessageFields() {
      const wrap = el('#devis-messages-now');
      let lines = FORMULE_LINES[state.formule];

      if (state.formule === 'repartition_perso') {
        const pimpe = Number(state.repartition_pimpe || 50);
        lines = [pimpe + ' % Pimpés', (100 - pimpe) + ' % Tout nus'];
      }

      if (!lines) lines = ['Votre biscuit'];

      wrap.innerHTML = lines.map((label, i) => (
        '<div class="devis-form__message-field">' +
          '<label class="devis-form__label" for="devis-message-' + i + '">Message — ' + label + '</label>' +
          '<textarea id="devis-message-' + i + '" name="message_' + i + '" maxlength="120" rows="3" data-required></textarea>' +
          '<span class="devis-form__message-counter" data-counter-for="devis-message-' + i + '">120 caractères restants</span>' +
        '</div>'
      )).join('');

      els('textarea[maxlength]', wrap).forEach((textarea) => {
        textarea.addEventListener('input', () => {
          const counter = el('[data-counter-for="' + textarea.id + '"]', wrap);
          if (counter) counter.textContent = (120 - textarea.value.length) + ' caractères restants';
        });
      });

      syncAllRequired();
    }

    // --- Écran 9 : abonnement --------------------------------------------------

    function onAbonnementChange(value) {
      el('.devis-form__abonnement-details').hidden = value !== 'oui';
      syncAllRequired();
    }

    // --- État global : un seul listener délégué ------------------------------

    form.addEventListener('change', (event) => {
      const target = event.target;
      if (!target.name) return;

      if (target.type === 'checkbox') {
        state[target.name] = els('[name="' + target.name + '"]:checked').map((c) => c.value);
      } else {
        state[target.name] = target.value;
      }

      if (target.name === 'vous_etes') onProfilChange(target.value);
      if (target.name === 'precision_livraison') onPrecisionLivraisonChange(target.value);
      if (target.name === 'formule') onFormuleChange(target.value);
      if (target.name === 'mode_livraison') onModeLivraisonChange(target.value);
      if (target.name === 'avancer') onAvancerChange(target.value);
      if (target.name === 'redaction_messages') onRedactionChange(target.value);
      if (target.name === 'abonnement') onAbonnementChange(target.value);
    });

    form.addEventListener('input', (event) => {
      const target = event.target;
      if (!target.name || target.type === 'checkbox' || target.type === 'radio') return;
      state[target.name] = target.value;
    });

    // --- Écran 10 : récapitulatif ---------------------------------------------

    function recapGroup(title, rows) {
      const filtered = rows.filter((row) => row[1] !== undefined && row[1] !== null && row[1] !== '');
      if (!filtered.length) return '';
      return (
        '<div class="devis-form__recap-group"><h3>' + title + '</h3><ul>' +
        filtered.map((row) => '<li><strong>' + row[0] + '</strong> — ' + row[1] + '</li>').join('') +
        '</ul></div>'
      );
    }

    function renderRecap() {
      const recap = el('#devis-recap');
      const s = state;
      const profilLabel = s.profil === 'professionnel'
        ? 'Professionnel' + (s.structure ? ' — ' + s.structure : '')
        : 'Particulier';

      const html = [
        recapGroup('Profil', [
          ['Vous êtes', profilLabel],
          ['Secteur', s.secteur],
          ['Contact', [s.prenom, s.nom].filter(Boolean).join(' ')],
          ['E-mail', s.email]
        ]),
        recapGroup('Projet', [
          ['Contexte', el('#devis-contexte') ? el('#devis-contexte').selectedOptions[0]?.text : null],
          ['Quantité', s.quantite ? s.quantite + ' biscuits' : null],
          ['Date de l’événement', s.date_evenement]
        ]),
        recapGroup('Formule', [
          ['Formule', FORMULE_LABELS[s.formule]],
          ['Répartition', s.formule === 'repartition_perso' && s.repartition_pimpe ? s.repartition_pimpe + ' % Pimpés' : null]
        ]),
        recapGroup('Personnalisation', [
          ['Nappage(s)', Array.isArray(s.nappage) ? s.nappage.join(', ') : null],
          ['Toppings', Array.isArray(s.topping) ? s.topping.join(', ') : null]
        ]),
        recapGroup('Conditionnement & livraison', [
          ['Conditionnement', Array.isArray(s.conditionnement) ? s.conditionnement.join(', ') : null],
          ['Étiquette personnalisée', s.etiquette],
          ['Mode de livraison', s.mode_livraison]
        ]),
        recapGroup('Vos mots', [
          ['Messages', s.redaction_messages === 'maintenant' ? 'Rédigés maintenant' : (s.redaction_messages === 'reflechir' ? 'À réfléchir' : null)]
        ]),
        recapGroup('Abonnement', [
          ['Transformer en abonnement', s.abonnement],
          ['Fréquence', s.abonnement_frequence]
        ])
      ].filter(Boolean).join('');

      recap.innerHTML = html || '<p class="devis-form__recap-empty">Rien à afficher pour le moment.</p>';
    }

    // --- Écran 11 : soumission finale ------------------------------------------
    // TODO Phase 2 : envoyer `state` au webhook Make / endpoint maison décrit
    // dans docs/04-integration-axonaut.md. Pour l'instant la validation avance
    // simplement vers l'écran "Merci" sans rien transmettre.

    // --- Initialisation ----------------------------------------------------

    populateContexteSelect('particulier');
    syncAllRequired();
    updateProgress('garde');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq__item-header').forEach((header) => {
    header.addEventListener('click', () => {
      const item = header.closest('.faq__item');
      const isOpen = item.classList.contains('faq__item--open');
      item.closest('.faq__list').querySelectorAll('.faq__item--open').forEach((openItem) => {
        openItem.classList.remove('faq__item--open');
        openItem.querySelector('.faq__item-header').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('faq__item--open');
        header.setAttribute('aria-expanded', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-header"]) return;
  try {
    
  document.querySelectorAll('.cachoteries-header').forEach((header) => {
    const burger = header.querySelector('[data-nav-burger]');
    const mobileMenu = header.querySelector('[data-nav-mobile]');
    const navWrapper = header.querySelector('[data-nav-wrapper]');

    if (burger && mobileMenu) {
      burger.addEventListener('click', () => {
        const isOpen = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', String(!isOpen));
        mobileMenu.hidden = isOpen;
        document.body.style.overflow = isOpen ? '' : 'hidden';
      });
    }

    if (navWrapper) {
      let lastScroll = 0;
      window.addEventListener('scroll', () => {
        const current = window.scrollY;
        if (Math.abs(current - lastScroll) < 8) return;
        if (current > lastScroll && current > 80) {
          navWrapper.classList.add('nav__wrapper--hidden');
        } else {
          navWrapper.classList.remove('nav__wrapper--hidden');
        }
        lastScroll = current;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-hero-contact-trigger]');
    if (trigger) {
      const popup = trigger.closest('.hero').querySelector('[data-hero-contact-popup]');
      if (popup) popup.hidden = false;
      return;
    }
    const closeEl = event.target.closest('[data-hero-contact-close]');
    if (closeEl) {
      closeEl.closest('[data-hero-contact-popup]').hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-hero-contact-popup]:not([hidden])').forEach((popup) => {
      popup.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-home-split"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.home-split__item-header').forEach((header) => {
    header.addEventListener('click', () => {
      const item = header.closest('.home-split__item');
      const isOpen = item.classList.contains('home-split__item--open');
      item.closest('.home-split__accordion').querySelectorAll('.home-split__item--open').forEach((openItem) => {
        openItem.classList.remove('home-split__item--open');
        openItem.querySelector('.home-split__item-header').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('home-split__item--open');
        header.setAttribute('aria-expanded', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-pdv-pro-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-contact-popup-trigger]');
    if (trigger) {
      const popup = document.querySelector('[data-contact-popup="' + trigger.dataset.contactPopupTrigger + '"]');
      if (popup) popup.hidden = false;
      return;
    }
    const closeEl = event.target.closest('[data-contact-popup-close]');
    if (closeEl) {
      closeEl.closest('[data-contact-popup]').hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-contact-popup]:not([hidden])').forEach((popup) => {
      popup.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-perso-composition"] && !Shopify.designMode) return;
  try {
    
  function equalizePersoCompoSteps() {
    document.querySelectorAll('.perso-compo__steps').forEach((stepsContainer) => {
      const steps = stepsContainer.querySelectorAll('.perso-compo__step');
      if (!steps.length) return;

      steps.forEach((step) => { step.style.minHeight = ''; });

      let maxHeight = 0;
      steps.forEach((step) => { maxHeight = Math.max(maxHeight, step.offsetHeight); });

      steps.forEach((step) => { step.style.minHeight = `${maxHeight}px`; });
    });
  }

  equalizePersoCompoSteps();

  if (document.fonts) {
    document.fonts.ready.then(equalizePersoCompoSteps);
  }

  let personCompoResizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(personCompoResizeTimeout);
    personCompoResizeTimeout = setTimeout(equalizePersoCompoSteps, 150);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-pro-brochure-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-contact-popup-trigger]');
    if (trigger) {
      const popup = document.querySelector('[data-contact-popup="' + trigger.dataset.contactPopupTrigger + '"]');
      if (popup) popup.hidden = false;
      return;
    }
    const closeEl = event.target.closest('[data-contact-popup-close]');
    if (closeEl) {
      closeEl.closest('[data-contact-popup]').hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-contact-popup]:not([hidden])').forEach((popup) => {
      popup.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-pro-devis"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-contact-popup-trigger]');
    if (trigger) {
      const popup = document.querySelector('[data-contact-popup="' + trigger.dataset.contactPopupTrigger + '"]');
      if (popup) popup.hidden = false;
      return;
    }
    const closeEl = event.target.closest('[data-contact-popup-close]');
    if (closeEl) {
      closeEl.closest('[data-contact-popup]').hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-contact-popup]:not([hidden])').forEach((popup) => {
      popup.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-pro-intro"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-contact-popup-trigger]');
    if (trigger) {
      const popup = document.querySelector('[data-contact-popup="' + trigger.dataset.contactPopupTrigger + '"]');
      if (popup) popup.hidden = false;
      return;
    }
    const closeEl = event.target.closest('[data-contact-popup-close]');
    if (closeEl) {
      closeEl.closest('[data-contact-popup]').hidden = true;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-contact-popup]:not([hidden])').forEach((popup) => {
      popup.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cachoteries-product-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const main = gallery.querySelector('.product-gallery__main-img');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (main) {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = thumb.dataset.fullSrc;
        }
        thumbs.forEach((t) => t.classList.remove('product-gallery__thumb--active'));
        thumb.classList.add('product-gallery__thumb--active');
      });
    });
  });

  document.querySelectorAll('.product-info').forEach((info) => {
    const qtyVal = info.querySelector('[data-qty-val]');
    const qtyInput = info.querySelector('[data-qty-input]');
    const minus = info.querySelector('[data-qty-minus]');
    const plus = info.querySelector('[data-qty-plus]');

    if (minus && plus && qtyVal && qtyInput) {
      let qty = 1;
      plus.addEventListener('click', () => {
        qty++;
        qtyVal.textContent = qty;
        qtyInput.value = qty;
      });
      minus.addEventListener('click', () => {
        if (qty > 1) {
          qty--;
          qtyVal.textContent = qty;
          qtyInput.value = qty;
        }
      });
    }

    info.querySelectorAll('[data-accordion-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.closest('.product__accordion-item').classList.toggle('product__accordion-item--open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
